import { initReactI18next } from "react-i18next";
import i18next from "i18next";

// Common
import enCommon from "./locales/common/en.json";
import esCommon from "./locales/common/es.json";

import enLogin from "../pages/login/locales/en.json";
import esLogin from "./../pages/login/locales/es.json";
import enAdminSections from "../Layouts/admin/locales/en.json";
import esAdminSections from "../Layouts/admin/locales/es.json";

import enHome from "../pages/home/locales/en.json";
import esHome from "../pages/home/locales/es.json";
import enLite from "../Layouts/lite/locales/en.json";
import esLite from "../Layouts/lite/locales/es.json";
import enEntregaServicio from "../Layouts/entrega-servicio/locales/en.json";
import esEntregaServicio from "../Layouts/entrega-servicio/locales/es.json";

// Truck Yards (Oasis)
import enSideMenu from "../Layouts/oasis/components/sideMenu/locales/en.json";
import esSideMenu from "../Layouts/oasis/components/sideMenu/locales/es.json";
import enYardsList from "../pages/oasis/yards-section/list/locales/en.json";
import esYardsList from "../pages/oasis/yards-section/list/locales/es.json";
import enYardsForm from "../pages/oasis/yards-section/form/locales/en.json";
import esYardsForm from "../pages/oasis/yards-section/form/locales/es.json";
import esAccessList from "../pages/oasis/access-section/locales/es.json";
import enAccessList from "../pages/oasis/access-section/locales/en.json";

// Session Reset
import enSessionReset from "../pages/public/confirm-session-reset/locales/en.json";
import esSessionReset from "../pages/public/confirm-session-reset/locales/es.json";

// Password Reset
import enPasswordReset from "../pages/public/reset-password/locales/en.json";
import esPasswordReset from "../pages/public/reset-password/locales/es.json";

// Reseller Admin
import enResellerAdmin from "../Layouts/reseller-admin/locales/en.json";
import esResellerAdmin from "../Layouts/reseller-admin/locales/es.json";

// Truck Yard (Patios de Maniobras)
import enTruckYard from "../pages/patios-maniobras/locales/en.json";
import esTruckYard from "../pages/patios-maniobras/locales/es.json";

// Cobranza Companies
import enCompanies from "../pages/cobranza/companies/locales/en.json";
import esCompanies from "../pages/cobranza/companies/locales/es.json";

// XML
import enXml from "../Layouts/xml/locales/en.json";
import esXml from "../Layouts/xml/locales/es.json";

import enSupport from "../pages/support/locales/en.json";
import esSupport from "../pages/support/locales/es.json";
// Wialon Dashboard
import enWialonDashboard from "../pages/dashboards/wialon/locales/en.json";
import esWialonDashboard from "../pages/dashboards/wialon/locales/es.json";

import enServiceDesk from "../Layouts/service-desk/locales/en.json";
import esServiceDesk from "../Layouts/service-desk/locales/es.json";

// SG
import enSg from "../pages/sg/locales/en.json";
import esSg from "../pages/sg/locales/es.json";

// Respaldos
import enRespaldos from "../pages/respaldos/locales/en.json";
import esRespaldos from "../pages/respaldos/locales/es.json";

const LANGUAGE_STORAGE_KEY = "app-language-preference";

function getStoredLanguage(): string {
  if (typeof window === "undefined") return "es";
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (stored === "en" || stored === "es") return stored;
  return "es";
}

i18next.use(initReactI18next).init({
  compatibilityJSON: "v4",
  lng: getStoredLanguage(),
  fallbackLng: "es",
  resources: {
    en: {
      common: enCommon,
      login: enLogin,
      adminSections: enAdminSections,
      // Truck Yards (Oasis)
      yardsList: enYardsList,
      sideMenu: enSideMenu,
      yardsForm: enYardsForm,
      accessList: enAccessList,
      // Home
      home: enHome,
      lite: enLite,
      // Entrega de Servicio
      entregaServicio: enEntregaServicio,
      // Session Reset
      sessionReset: enSessionReset,
      // Password Reset
      passwordReset: enPasswordReset,
      // Reseller Admin
      resellerAdmin: enResellerAdmin,
      // Truck Yard (Patios de Maniobras)
      truckYard: enTruckYard,
      // Cobranza Companies
      companies: enCompanies,
      // XML
      xml: enXml,
      // Support
      support: enSupport,
      // Wialon Dashboard
      wialonDashboard: enWialonDashboard,
      // Service Desk
      serviceDesk: enServiceDesk,
      // SG
      sg: enSg,
      // Respaldos
      respaldos: enRespaldos,
    },
    es: {
      common: esCommon,
      login: esLogin,
      adminSections: esAdminSections,
      // Truck Yards (Oasis)
      yardsList: esYardsList,
      sideMenu: esSideMenu,
      yardsForm: esYardsForm,
      accessList: esAccessList,
      // Home
      home: esHome,
      lite: esLite,
      // Entrega de Servicio
      entregaServicio: esEntregaServicio,
      // Session Reset
      sessionReset: esSessionReset,
      // Password Reset
      passwordReset: esPasswordReset,
      // Reseller Admin
      resellerAdmin: esResellerAdmin,
      // Truck Yard (Patios de Maniobras)
      truckYard: esTruckYard,
      // Cobranza Companies
      companies: esCompanies,
      // XML
      xml: esXml,
      // Support
      support: esSupport,
      // Wialon Dashboard
      wialonDashboard: esWialonDashboard,
      // Service Desk
      serviceDesk: esServiceDesk,
      // SG
      sg: esSg,
      // Respaldos
      respaldos: esRespaldos,
    },
  },
});

// Persist language changes to localStorage
i18next.on("languageChanged", (lng: string) => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
});

export default i18next;
export { LANGUAGE_STORAGE_KEY };
